import { Button, Stack, Typography } from "@mui/material";
import { forwardRef } from "react";
import Modal, { CommonModalProps } from "..";
import { useTranslation } from "react-i18next";

export type ModalLoginExceptionProps = {
  onClose?: (props: CloseClbProps) => void;
  title: string;
  message: string;
  advice: string;
};
type CloseClbProps = {
  collectionName: string;
};

export type ModalLoginProps = CommonModalProps<ModalLoginExceptionProps>;

const ModalLoginException = forwardRef<any, ModalLoginProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onClose, ...elementProps } = props;
  const { title = "", message = "", advice = "" } = elementProps;

  return (
    <Modal
      title={title}
      closeModal={closeModal}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1.5}></Stack>
          <Button onClick={closeModal}>{t("common:close")}</Button>
        </Stack>
      }
    >
      {message.split("\n").map((text) => (
        <Typography key={text}>{text}</Typography>
      ))}
      <span>{advice}</span>
    </Modal>
  );
});

export default ModalLoginException;
